export const GlobalAbortControllers = new Map()

export const GlobalAbortControllerCancelSignal = () => {
  if (GlobalAbortControllers.size > 0) {
    GlobalAbortControllers?.forEach(value => value?.abort)
  }

  return
}
// this naive implementation is only for the case of aborting controllers, this has to be extended to accomodate an object that contains maps of abortControllers.
